/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import jMoment from 'moment-jalaali'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import moment from 'moment'
import $ from 'jquery'
import {message} from 'antd'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import DeliveryPackComponent from '../BaseComponent/deliveryPackComponent'
import DeliveryPackPrint from '../BaseComponent/deliveryPackPrint'

class FactorDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Factors: [],
      printInfo: [],
      modal: false,
      urlSign: '',
      lengthProducts: '',
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      Drivers: [],
      aggregation: {}
    }
  }

  changeState(e) {
    let target = e.target
    let value = target.value

    this.setState({
      state: value
      // ,
      // tasvie:lasttasvie
    })
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    const {dispatchId} = this.props.match.params

    sessionStorage.setItem('params', `dispatchId=${dispatchId}`)

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER
        }?export=false&pageSize=10&pageNumber=1&dispatchId=${dispatchId}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          sessionStorage.setItem('countAll', response.data.object.countAll)

          $('.showBaseTable,.print').fadeIn()

          this.setState({
            Factors: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
        }
      })
      .catch((error) => {
        //alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      Factors: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Factors: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let buyerName = document.getElementById('buyerName').value
    let recipientName = document.getElementById('recipientName').value
    let isPaid = document.getElementById('isPaid').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let totalAmountMin = this.convertDigit(document.getElementById('totalAmountMin').value.trim())
    let totalAmountMax = this.convertDigit(document.getElementById('totalAmountMax').value.trim())
    let lastState = document.getElementById('lastState').value
    var {dispatchId} = this.props.match.params

    sessionStorage.setItem(
      'params',
      `dispatchId=${dispatchId}&invoiceNum=${invoiceNum}&invoiceId=${invoiceId}&buyerName=${buyerName}&recipientName=${recipientName}&isPaid=${isPaid}&payOnDelivery=${payOnDelivery}&totalAmountMin=${totalAmountMin}&totalAmountMax=${totalAmountMax}&lastState=${lastState}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`
    )
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER
        }/?export=false&pageSize=10&pageNumber=1&dispatchId=${dispatchId}&invoiceNum=${invoiceNum}&invoiceId=${invoiceId}&buyerName=${buyerName}&recipientName=${recipientName}&isPaid=${isPaid}&payOnDelivery=${payOnDelivery}&totalAmountMin=${totalAmountMin}&totalAmountMax=${totalAmountMax}&lastState=${lastState}&sortBy=planDate_Desc,planTimeFrom_Asc,invoiceNum_Asc`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)
          $('.showBaseTable,.print').fadeIn()

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            Factors: response.data.object.result,
            lengthbaskets: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }

            if (excelReport[i].driver == null) {
              excelReport[i].driver = ''
            } else {
              excelReport[i].driver = excelReport[i].driver['name']
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  getSort = (sortBy) => {}

  render() {
    const {name} = this.props.match.params
    let url = `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}&` + sessionStorage.getItem('params')
    let urlExcel = `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}?export=true`
    let urlParams = sessionStorage.getItem('params')
    let excelColumns = [
      {title: 'شناسه', value: 'deliveryPackId'},
      {title: 'شناسه فاکتور', value: 'invoiceId'},
      {title: 'شماره فاکتور', value: 'invoiceNum'},
      {title: 'قیمت کل', value: 'totalAmount'},
      {title: 'قیمت نهایی', value: 'afterDiscountAmount'},
      {title: 'قیمت قابل پرداخت', value: 'payableAmount'},
      {title: 'آدرس', value: 'address'},
      {title: 'تحویل گیرنده', value: 'recipientName'}
    ]

    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش پارت تحویل.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'نام خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'nationalId'}
                field={'customer.nationalId'}
                title={'کد ملی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'totalInfo.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'cash'}
                field={'payment.cash'}
                title={'پرداخت نقدی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'card'}
                field={'payment.card'}
                title={'پرداخت کارتخوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'prePaid'}
                field={'payment.prePaid'}
                title={'پرداخت از قبل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <DeliveryPackPrint
          printInfo={this.state.printInfo}
          aggregation={this.state.aggregation}
          rightSectionPrint={' رساننده : ' + name}
          centerSection={''}
        />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>{'پارت تحویل رساننده'}</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={url}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="/printBaskets"
                  printComponent={this.printTable}
                  execelUrl={urlExcel}
                  excelColumns={excelColumns}
                  titleAdd=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceId" name="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="isPaid" name="isPaid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>مبلغ کل از :</label>
                  <input type="text" className="form-control" id="totalAmountMin" name="totalAmountMin" />
                </div>

                <div className="formComponent">
                  <label>مبلغ کل تا :</label>
                  <input type="text" className="form-control" id="totalAmountMax" name="totalAmountMax" />
                </div>

                <div className="formComponent">
                  <label>حالت:</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="lastState"
                    name="lastState"
                  >
                    <option value="">-------</option>
                    <option value="-100">کنسل</option>
                    <option value="-75">مرجوعی</option>
                    <option value="-50">بازگشتی</option>
                    <option value="100">تخصیص مجدد</option>
                    <option value="-1">تخصیص داده نشده</option>
                    <option value="1">فعال</option>
                    <option value="15">تحویل ناقص</option>
                    <option value="5">اول فعال</option>
                    <option value="10">شروع شده</option>
                    <option value="18">تسویه شده</option>
                  </select>
                </div>

                {/*<div className='formComponent'>*/}
                {/*<label>نوع تسویه :</label>*/}
                {/*<select className='form-control' id='hasSign' onChange={this.changeField.bind(this)}  name='hasSign'>*/}
                {/*<option value=''>-------</option>*/}
                {/*<option value={1}>با امضا</option>*/}
                {/*<option value={0}>با کد</option>*/}
                {/*</select>*/}

                {/*</div>*/}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="detailsInfoTable">
              <ul>
                <li>نام رساننده : {name}</li>
              </ul>
            </div>
            <DeliveryPackComponent
              deliveryPackData={this.state.Factors}
              aggregation={this.state.aggregation}
              pageNumber={sessionStorage.getItem('pageNumber')}
              pageSize={sessionStorage.getItem('dropDownVal')}
              getDeliverySort={this.getSort}
            />
            <div className="paginationWrapp baseTable showBaseTable">
              <Page
                defaultCurrent={1}
                total={this.state.lengthProducts}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}
                urlParams={urlParams}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FactorDrivers
